
import { Component, Vue, Watch } from 'vue-property-decorator'
const dj_brief = require('./../../../assets/imgs/dj_brief.png'),
  dj_first_try = require('./../../../assets/imgs/dj_first_try.png'),
  dj_second_try = require('./../../../assets/imgs/dj_second_try.png'),
  dj_train = require('./../../../assets/imgs/dj_train.png'),
  dj_internship = require('./../../../assets/imgs/dj_internship.png'),
  dj_assessment = require('./../../../assets/imgs/dj_assessment.png'),
  dj_platform = require('./../../../assets/imgs/dj_platform.png');
@Component({
  name: 'DashJoingenius'
})
export default class DashJoingenius extends Vue {
  private setepLists: Array<any> = [
    { icon: dj_brief, title: '投简历', rate: '80%的筛选率', others: '从重点大学选优等生' },
    { icon: dj_first_try, title: '初试', rate: '60%的通过率', others: '从优等生中选合适的人' },
    { icon: dj_second_try, title: '复试', rate: '30%的通过率', others: '能力与品质两手抓' },
    { icon: dj_train, title: '培训（7天）', rate: '15%的通过率', others: '爱与责任是科吉不变的初心' },
    { icon: dj_internship, title: '实习（3个月）', rate: '5%的通过率', others: '确保每个老师没有短板' },
    { icon: dj_assessment, title: '最终考核', rate: '2.47%的通过率', others: '真正做到优中选优' },
    { icon: dj_platform, title: '走向讲台', rate: '', others: '每位老师都值得信赖' }
  ]
  private djcContWidth = 0
  beforeMount() {
    // this.djcContWidth = document.body.clientWidth * 1212 / 1920
    if (document.body.clientWidth <= 1280) {
      this.djcContWidth = 1060
    } else {
      this.djcContWidth = document.body.clientWidth * 1212 / 1920
    }
  }
}
